import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import {keys as alarmSchemeKeys} from "../alarm-scheme-admin/Keys";
import { IAlarmScheduleModel } from "../../services/alarm-schedule-data-service/Models";
import AlarmScheduleAdministrationDataService from "../../services/alarm-schedule-data-service/AlarmScheduleAdministrationService";

export type MutationContextType = {
    previous: IAlarmScheduleModel | undefined;
};

export type UseSaveAlarmScheduleParameters = {
    groupID: number,
    organizationID: number
} & BaseUseMutationParameters<IAlarmScheduleModel, IAlarmScheduleModel>;

export function useSaveAlarmSchedule({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseSaveAlarmScheduleParameters) {
    const queryClient = useQueryClient();

    return useMutation<IAlarmScheduleModel, RestError, IAlarmScheduleModel, MutationContextType>(
        (schedule) => {
            return AlarmScheduleAdministrationDataService.saveAlarmSchedule(
                organizationID,
                groupID,
                schedule
            );
        },
        {
            onMutate: async (item: IAlarmScheduleModel) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all, alarmSchemeKeys.referenceData],
                    active: true,
                    inactive: true
                });

                queryClient.refetchQueries({
                    queryKey: [keys.alarmSchedules],
                    active: true,
                    inactive: true
                });

                if (item.id > 0) {
                    queryClient.setQueryData<IAlarmScheduleModel>(keys.alarmSchedule(organizationID, groupID, item.id, false), item);
                }

                const prev = queryClient.getQueryData<IAlarmScheduleModel>(keys.alarmSchedule(organizationID, groupID, item.id, false));

                return {
                    previous: prev ?? item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            // onSettled: (_data, error, _configuration, context) => {

            //     if (error && context?.previous) {
            //         queryClient.setQueryData<Array<I>>(
            //             keys.alarmSchedules(
            //                 customerID,
            //                 groupID,
            //                 contextObject,
            //                 offline ?? false,
            //                 timestamp
            //             ),
            //             context?.previousRunTickets
            //         );
            //     }

            //     queryClient.invalidateQueries(keys.lists());
            // }
        }
    );
}
